var _ellipse, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatHelpExpertProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 111,
    viewBox: "0 0 113 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.5,
    cy: 55.5,
    rx: 55.5,
    ry: 54.5,
    fill: "white",
    stroke: "#5956E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0535 43.7992C63.48 43.7699 68.6657 38.44 68.6358 31.8945C68.606 25.3491 63.372 20.0666 56.9455 20.0959C50.5189 20.1252 45.3333 25.4551 45.3631 32.0006C45.393 38.5461 50.627 43.8285 57.0535 43.7992ZM78.1178 69.7774C78.1715 81.5593 68.8375 91.1531 57.2696 91.2058C45.7016 91.2585 36.2806 81.7503 36.2269 69.9683C36.1732 58.1864 45.5072 48.5926 57.0751 48.5399C68.6431 48.4872 78.0641 57.9954 78.1178 69.7774ZM68.0872 61.0356C67.174 60.1144 65.7004 60.1211 64.7955 61.0506L52.5349 73.6529L49.5123 70.6018C48.599 69.6806 47.1254 69.6873 46.2206 70.6168C45.3162 71.5468 45.3231 73.0477 46.2359 73.9694L50.912 78.6888C51.8253 79.6101 53.2989 79.6034 54.2037 78.6738L68.1025 64.3882C69.0069 63.4582 69 61.9573 68.0872 61.0356Z",
    fill: "#5956E9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 70,
    r: 15,
    fill: "#32CE38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4422 64.4595C64.7986 63.8103 63.7601 63.815 63.1225 64.4701L54.4823 73.3511L52.3521 71.2009C51.7086 70.5517 50.6701 70.5565 50.0324 71.2115C49.3951 71.8669 49.3999 72.9246 50.0432 73.5741L53.3386 76.9C53.9821 77.5492 55.0206 77.5445 55.6583 76.8894L65.453 66.8221C66.0903 66.1667 66.0855 65.109 65.4422 64.4595Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatHelpExpertProfile);
export default __webpack_public_path__ + "static/media/ChatHelpExpertProfile.05bedb7f00e480a64eafce524868eb3a.svg";
export { ForwardRef as ReactComponent };